<script lang="ts">
  import { page } from '$app/stores';
  import { sendAnalyticsEvent } from '$lib/services/analytics';
  import { navigateWithinSiteStore } from '$lib/store';
  import { EventNames } from '$lib/types/analytics';
  import type { Category } from '$lib/types/category';

  import CategoryNavButton from './CategoryNavButton.svelte';

  export let categories: Category[];
  const checkIsActive = (path: string, pathname: string) => {
    if (path !== '/' && pathname.includes(path)) {
      return true;
    }
    return path === pathname;
  };

  const handleClick = (categoryName: string) => {
    if (categoryName == 'Home') {
      navigateWithinSiteStore.update((obj) => {
        obj.fromInternal = true;
        return obj;
      });
    }
    sendAnalyticsEvent(EventNames.ZAPP_CATEGORY_CLICK, {
      category_name: categoryName
    });
  };
</script>

<nav class="category-navbar">
  {#each categories as category (category.name)}
    {@const isActive = checkIsActive(category.path, $page.url.pathname)}
    <CategoryNavButton path={category.path} categoryName={category.name} {isActive} {handleClick} />
  {/each}
</nav>

<style lang="scss">
  .category-navbar {
    height: var(--height-category-navbar);
    // background: var(--color-category-navbar-background);
    align-items: center;
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    justify-content: center;
    padding: 0 12px;
    overflow: scroll;
    &::-webkit-scrollbar {
      display: none;
    }
  }
</style>
